<template>
  <div class="dialog-agent-editor-wrapper">
    <el-dialog
      width="50%"
      :title="title"
      :visible="visible"
      :close-on-click-modal="false"
      @open="onDialogOpen"
      @close="onDialogClose">
      <el-form ref="form" :rules="formRule" :model="formData">

        <div class="form-item-logo-upload">
          <div class="upload-wrapper">
            <div class="upload">
              <input type="file" name="logo_icon" ref="logo-icon" @change="onLogoIconUpload">
              <img
                alt="logo-icon"
                :src="formData.logo_icon"
                v-if="formData.logo_icon !== ''">
              <i class="iconfont icon-upload-file" v-else></i>
            </div>
            <p>PC端菜单栏缩小Logo</p>
          </div>

          <div class="upload-wrapper">
            <div class="upload full">
              <input type="file" class="full" name="logo_color_full" ref="logo-color-full" @change="onLogoColorFullUpload">
              <img
                :src="formData.logo_color_full"
                alt="logo-color-full"
                class="full"
                v-if="formData.logo_color_full !== ''">
              <i class="iconfont icon-upload-file" v-else></i>
            </div>
            <p>彩色长 Logo（移动端）</p>
          </div>

          <div class="upload-wrapper">
            <div class="upload full">
              <input type="file" class="full" name="logo_white_full" ref="logo-white-full" @change="onLogoWhiteFullUpload">
              <img
                alt="logo-white-full"
                :src="formData.logo_white_full"
                class="full"
                v-if="formData.logo_white_full !== ''">
              <i class="iconfont icon-upload-file" v-else></i>
            </div>
            <p>白色长 Logo（PC端, 安卓端）</p>
          </div>
        </div>

        <el-form-item label="代理商名称" prop="agentname">
          <el-input
            placeholder="请输入代理商名称"
            v-model="formData.agentname" />
        </el-form-item>

        <el-form-item label="代理商昵称" prop="nickname">
          <el-input
            placeholder="请输入代理商昵称"
            v-model="formData.nickname" />
        </el-form-item>

        <el-form-item label="手机号码" prop="phone">
          <el-input
            placeholder="请输入手机号码"
            v-model="formData.phone" />
        </el-form-item>

        <el-form-item label="代理商主营业务" prop="business">
          <el-input
            placeholder="请输入代理商主营业务"
            v-model="formData.business" />
        </el-form-item>

        <el-form-item label="微信公众号 APP ID" prop="app_id">
          <el-input
            placeholder="请输入微信公众号 APP ID"
            v-model="formData.app_id" />
        </el-form-item>

        <el-form-item label="微信公众号 APP SECRET" prop="app_secret">
          <el-input
            placeholder="请输入微信公众号 APP SECRET"
            v-model="formData.app_secret" />
        </el-form-item>

        <el-form-item label="代理商密码" prop="password">
          <el-input
            type="password"
            placeholder="请输入代理商密码"
            v-model="formData.password" />
        </el-form-item>

        <el-form-item label="是否启用扩展密码" prop="is_oper_pwd">
          <el-radio v-model="formData.is_oper_pwd" :label="0">禁用</el-radio>
          <el-radio v-model="formData.is_oper_pwd" :label="1">启用</el-radio>
        </el-form-item>

        <el-form-item label="代理商操作密码" prop="oper_pwd" v-show="formData.is_oper_pwd === 1">
          <el-input
            type="password"
            placeholder="请输入代理商操作密码"
            v-model="formData.oper_pwd" />
        </el-form-item>

        <el-form-item label="费率" prop="fee_value">
          <el-input
            placeholder="请输入支付费率"
            type="number"
            v-model="formData.fee_value" />
        </el-form-item>

        <el-form-item label="支付渠道" prop="pay_channel">
          <el-select
            style="width: 100%"
            v-model="formData.pay_channel"
            placeholder="请选择支付渠道">
            <el-option label="京东" value="jd"></el-option>
            <el-option label="扫呗" value="sb"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="支付抬头" prop="pay_title">
          <el-input
            placeholder="请输入支付抬头"
            v-model="formData.pay_title" />
        </el-form-item>

        <el-form-item label="支付域名" prop="pay_domain">
          <el-input
            placeholder="请输入支付域名"
            v-model="formData.pay_domain" />
        </el-form-item>

        <el-form-item label="支付后台域名" prop="wechat_admin_domain">
          <el-input
            placeholder="请输入后台域名"
            v-model="formData.wechat_admin_domain" />
        </el-form-item>

        <el-form-item label="用户信息授权域名" prop="wechat_auth_domain">
          <el-input
            placeholder="请输入用户信息授权域名"
            v-model="formData.wechat_auth_domain" />
        </el-form-item>

        <el-form-item label="中文版权所有" prop="cn_copy_right">
          <el-input
            placeholder="请输入中文版权所有"
            v-model="formData.cn_copy_right" />
        </el-form-item>

        <el-form-item label="英文版权所有" prop="en_copy_right">
          <el-input
            placeholder="请输入英文版权所有"
            v-model="formData.en_copy_right" />
        </el-form-item>

        <el-form-item label="子用户后缀" prop="sub_user_suffix">
          <el-input
            placeholder="请输入子用户后缀"
            v-model="formData.sub_user_suffix" />
        </el-form-item>

        <el-form-item label="备注" prop="remarks">
          <el-input
            placeholder="备注"
            v-model="formData.remarks" />
        </el-form-item>

      </el-form>

      <div class="submit-box">
        <el-button
          type="danger"
          @click="onFormSubmit">确定</el-button>
        <el-button @click="onFormCancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import agentApi from '@/api/agentApi'

export default {
  name: 'DialogAgentEditor',
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    mode: {
      type: String,
      required: false,
      default: 'create'
    },
    agent: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      formRule: {
        agentname: [
          { required: true, message: '请输入代理商名称', trigger: 'blur' }
        ],
        nickname: [
          { required: true, message: '请输入代理商昵称', trigger: 'blur' }
        ],
        az_cn_logo: [
          { required: true, message: '请输入安卓端中文 logo　地址', trigger: 'blur' }
        ],
        az_enlogo: [
          { required: true, message: '请输入安卓端英文 logo　地址', trigger: 'blur' }
        ],
        business: [
          { required: true, message: '请输入代理商主要业务', trigger: 'blur' }
        ],
        app_id: [
          { required: true, message: '请输入微信公众号 APP ID', trigger: 'blur' }
        ],
        app_secret: [
          { required: true, message: '请输入微信公众号 APP SECRET', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入代理商密码', trigger: 'blur' }
        ],
        cn_copy_right: [
          { required: true, message: '请输入中文版权信息', trigger: 'blur' }
        ],
        en_copy_right: [
          { required: true, message: '请输入英文版权信息', trigger: 'blur' }
        ],
        start_at: [
          { required: true, message: '请输入代理商有效期开始时间', trigger: 'change' }
        ],
        expired_at: [
          { required: true, message: '请输入代理商有效期结束时间', trigger: 'change' }
        ],
        logo_icon: [
          { required: true, message: '请输入 logo 地址', trigger: 'blur' }
        ],
        m_cnlogo: [
          { required: true, message: '请输入移动端中文 logo 地址', trigger: 'blur' }
        ],
        m_enlogo: [
          { required: true, message: '请输入移动端英文 logo 地址', trigger: 'blur' }
        ],
        pay_channel: [
          { required: true, message: '请选择支付渠道', trigger: 'change' }
        ],
        pay_domain: [
          { required: true, message: '请输入支付域名', trigger: 'blur' }
        ],
        pay_title: [
          { required: true, message: '请输入支付抬头', trigger: 'blur' }
        ],
        pc_cnlogo: [
          { required: true, message: '请输入 pc 中文 logo 地址请输入代理商昵称', trigger: 'blur' }
        ],
        pc_enlogo: [
          { required: true, message: '请输入 pc 英文 logo 地址', trigger: 'blur' }
        ],
        wechat_admin_domain: [
          { required: true, message: '请输入后台域名', trigger: 'blur' }
        ],
        wechat_auth_domain: [
          { required: true, message: '请输入授权域名', trigger: 'blur' }
        ]
      },
      formData: {
        agentid: '',
        agentname: '',
        nickname: '',
        phone: '',
        business: '自动售货机',
        app_id: '',
        app_secret: '',
        password: '',
        is_oper_pwd: 0,
        oper_pwd: '',
        fee_value: '0.6',
        pay_channel: 'jd',
        pay_title: '红粟科技有限公司',
        pay_domain: 'https://pay.ckingdomtechnology.com',
        wechat_admin_domain: 'https://m.ckingdomtechnology.com',
        wechat_auth_domain: 'https://m.ckingdomtechnology.com',
        logo_icon: '',
        logo_icon_file: '',
        logo_color_full: '',
        logo_color_full_file: '',
        logo_white_full: '',
        logo_white_full_file: '',
        cn_copy_right: '云上数集',
        en_copy_right: 'ditigram',
        sub_user_suffix: '',
        remarks: ''
      }
    }
  },
  computed: {
    title () {
      if (this.mode === 'create') {
        return '添加代理商'
      } else {
        return `修改代理商（${this.agent.agentid} - ${this.agent.agentname} - ${this.agent.nickname}）`
      }
    }
  },
  methods: {
    onLogoIconUpload () {
      const file = this.$refs['logo-icon'].files[0]

      const reader = new FileReader()
      reader.onload = (event) => {
        this.formData.logo_icon = event.target.result
      }
      reader.readAsDataURL(file)
      this.formData.logo_icon_file = file
    },
    onLogoColorFullUpload () {
      const file = this.$refs['logo-color-full'].files[0]

      const reader = new FileReader()
      reader.onload = (event) => {
        this.formData.logo_color_full = event.target.result
      }
      reader.readAsDataURL(file)
      this.formData.logo_color_full_file = file
    },
    onLogoWhiteFullUpload () {
      const file = this.$refs['logo-white-full'].files[0]

      const reader = new FileReader()
      reader.onload = (event) => {
        this.formData.logo_white_full = event.target.result
      }
      reader.readAsDataURL(file)
      this.formData.logo_white_full_file = file
    },

    async onDialogOpen () {
      if (this.mode === 'create') {
        this.formData = {
          agentname: '',
          nickname: '',
          phone: '',
          business: '自动售货机',
          app_id: '',
          app_secret: '',
          password: '',
          is_oper_pwd: 0,
          oper_pwd: '',
          fee_value: '0.6',
          pay_channel: 'jd',
          pay_title: '红粟科技有限公司',
          pay_domain: 'https://pay.ckingdomtechnology.com',
          wechat_admin_domain: 'https://m.ckingdomtechnology.com',
          wechat_auth_domain: 'https://m.ckingdomtechnology.com',
          logo_icon: '',
          logo_icon_file: '',
          logo_color_full: '',
          logo_color_full_file: '',
          logo_white_full: '',
          logo_white_full_file: '',
          cn_copy_right: '云上数集',
          en_copy_right: 'ditigram',
          sub_user_suffix: '',
          remarks: ''
        }
      } else {
        this.formData = {
          agentid: this.agent.agentid,
          agentname: this.agent.agentname,
          nickname: this.agent.nickname,
          phone: this.agent.phone,
          business: this.agent.business,
          app_id: this.agent.app_id,
          app_secret: this.agent.app_secret,
          password: this.agent.password,
          is_oper_pwd: this.agent.is_oper_pwd,
          oper_pwd: this.agent.oper_pwd,
          fee_value: this.agent.fee_value,
          pay_channel: this.agent.pay_channel,
          pay_title: this.agent.pay_title,
          pay_domain: this.agent.pay_domain,
          wechat_admin_domain: this.agent.wechat_admin_domain,
          wechat_auth_domain: this.agent.wechat_auth_domain,
          logo_icon: this.agent.logo_icon,
          logo_icon_file: '',
          logo_color_full: this.agent.m_cnlogo,
          logo_color_full_file: '',
          logo_white_full: this.agent.pc_cnlogo,
          logo_white_full_file: '',
          cn_copy_right: this.agent.cn_copy_right,
          en_copy_right: this.agent.en_copy_right,
          sub_user_suffix: this.agent.sub_user_suffix,
          remarks: this.agent.remarks
        }
      }
    },
    onDialogClose () {
      this.$emit('change', false)
      this.$refs['form'].resetFields()
    },

    async createAgent () {
      const loading = this.$loading({
        lock: true,
        text: '请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      try {
        await agentApi.addAgent({
          agentname: this.formData.agentname,
          nickname: this.formData.nickname,
          phone: this.formData.phone,
          business: this.formData.business,
          app_id: this.formData.app_id,
          app_secret: this.formData.app_secret,
          password: this.formData.password,
          is_oper_pwd: this.formData.is_oper_pwd,
          oper_pwd: this.formData.oper_pwd,
          fee_value: this.formData.fee_value,
          pay_channel: this.formData.pay_channel,
          pay_title: this.formData.pay_title,
          pay_domain: this.formData.pay_domain,
          wechat_admin_domain: this.formData.wechat_admin_domain,
          wechat_auth_domain: this.formData.wechat_auth_domain,
          logo_icon: this.formData.logo_icon_file,
          logo_color_full: this.formData.logo_color_full_file,
          logo_white_full: this.formData.logo_white_full_file,
          cn_copy_right: this.formData.cn_copy_right,
          en_copy_right: this.formData.en_copy_right,
          sub_user_suffix: this.formData.sub_user_suffix,
          remarks: this.formData.remarks
        })
        this.$message({
          type: 'success',
          message: '创建代理商成功'
        })
        this.$emit('change', false)
        this.$emit('data-change')
        this.$refs['form'].resetFields()
      } catch (err) {
        this.$message({
          type: 'error',
          message: '创建代理商失败'
        })
        console.log(err)
      }
      loading.close()
    },
    async updateAgent () {
      const loading = this.$loading({
        lock: true,
        text: '请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      try {
        await agentApi.editAgent({
          agentid: this.formData.agentid,
          agentname: this.formData.agentname,
          nickname: this.formData.nickname,
          phone: this.formData.phone,
          business: this.formData.business,
          app_id: this.formData.app_id,
          app_secret: this.formData.app_secret,
          password: this.formData.password,
          is_oper_pwd: this.formData.is_oper_pwd,
          oper_pwd: this.formData.oper_pwd,
          fee_value: this.formData.fee_value,
          pay_channel: this.formData.pay_channel,
          pay_title: this.formData.pay_title,
          pay_domain: this.formData.pay_domain,
          wechat_admin_domain: this.formData.wechat_admin_domain,
          wechat_auth_domain: this.formData.wechat_auth_domain,
          logo_icon: this.formData.logo_icon_file,
          logo_color_full: this.formData.logo_color_full_file,
          logo_white_full: this.formData.logo_white_full_file,
          cn_copy_right: this.formData.cn_copy_right,
          en_copy_right: this.formData.en_copy_right,
          sub_user_suffix: this.formData.sub_user_suffix,
          remarks: this.formData.remarks
        })
        this.$message({
          type: 'success',
          message: '更新代理商成功'
        })
        this.$emit('change', false)
        this.$emit('data-change')
        this.$refs['form'].resetFields()
      } catch (err) {
        this.$message({
          type: 'error',
          message: '更新代理商失败'
        })
        console.log(err)
      }
      loading.close()
    },

    async onFormSubmit () {
      try {
        await this.$refs['form'].validate()

        if (this.mode === 'create') {
          // Require logo.
          if (this.formData.logo_icon_file === '' || this.formData.logo_color_full_file === '' ||
              this.formData.logo_white_full_file === '') {
            this.$message({
              type: 'error',
              message: '请上传代理商 Logo'
            })
            return
          }
          await this.createAgent()
        } else {
          await this.updateAgent()
        }
      } catch (err) {
        console.log(err)
      }
    },
    onFormCancel () {
      this.onDialogClose()
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-agent-editor-wrapper {

  .form-item-logo-upload {
    display: flex;
    justify-content: space-around;
    margin: 2rem 0;

    .upload-wrapper {
      display: flex;
      flex-flow: column;
      align-items: center;

      .upload {
        height: 6rem;
        width: 6rem;
        border: 1px dashed #666;
        border-radius: 10px;
        box-sizing: border-box;
        background-color: #f56c6c;
        text-align: center;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;

        &.full {
          width: 10rem;
        }

        i {
          font-size: 1.4rem;
          color: #FFFFFF;
        }
        p {
          font-size: .8rem;
        }
        input {
          width: 6rem;
          height: 6rem;
          position: absolute;
          opacity: 0;
          cursor: pointer;
          z-index: 99;

          &.full {
            width: 10rem;
          }
        }
        img {
          width: 5rem;
          height: 5rem;
          position: absolute;
          object-fit: contain;

          &.full {
            width: 9rem;
          }
        }
      }
    }
  }

  .submit-box {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/user/components/DialogAgentEditor.vue